import { defineMessages } from 'react-intl'

export default defineMessages({
  settingTheScene: {
    id: 'containers.SupplierProfile.components.SettingTheScene.settingTheScene',
    defaultMessage: '',
  },
  goodImpression: {
    id: 'containers.SupplierProfile.components.SettingTheScene.goodImpression',
    defaultMessage: 'Make a good first impression by adding a high quality logo, investor name and a short and crisp description.',
  },
  profilePicture: {
    id: 'containers.SupplierProfile.components.SettingTheScene.profilePicture',
    defaultMessage: 'Profile picture',
  },
  addProfilePhoto: {
    id: 'containers.SupplierProfile.components.SettingTheScene.addProfilePhoto',
    defaultMessage: 'Optionally upload an image for you profile (min. 200x200px). Your profile picture will not be visible on the VoiceArchive website.',
  },
  selectFile: {
    id: 'containers.SupplierProfile.components.SettingTheScene.selectFile',
    defaultMessage: 'Select file',
  },
  name: {
    id: 'containers.SupplierProfile.components.SettingTheScene.name',
    defaultMessage: 'Name',
  },
  enterName: {
    id: 'containers.SupplierProfile.components.SettingTheScene.enterName',
    defaultMessage: 'Enter name',
  },
  shortDescription: {
    id: 'containers.SupplierProfile.components.SettingTheScene.shortDescription',
    defaultMessage: 'Short description',
  },
  enterDescription: {
    id: 'containers.SupplierProfile.components.SettingTheScene.enterDescription',
    defaultMessage: 'Enter a short description here',
  },
  enterDescriptionInformation: {
    id: 'containers.SupplierProfile.components.SettingTheScene.enterDescriptionInformation',
    defaultMessage: 'Add a description between 100 and 2000 characters',
  },
})